import { MemoryStorageService } from './memory-storage.service';
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { IStorageService } from '../interfaces/IStorageService';

@Injectable({
  providedIn: 'root',
  deps: [MemoryStorageService],
})
export class StorageServiceService {
  private _storage: IStorageService;

  constructor(
    @Inject(PLATFORM_ID) public platformId: Record<string, unknown>,
    private memoryStorage: MemoryStorageService
  ) {
    this._storage = isPlatformBrowser(this.platformId)
      ? sessionStorage
      : this.memoryStorage;
  }

  public get storage(): IStorageService {
    return this._storage;
  }
}
